import { useRef } from 'react';
import { OpacitySlider } from '@/components/opacity-slider';
import { useEditor } from '@/hooks/use-editor';
import { useListenActivePickLayerProps } from '@/hooks/use-listen-layer-props';
import { type WidgetCommonProps } from '../../types';
import { Tracker } from '../../utils';

type Props = WidgetCommonProps;

export const LayerOpacity: React.FC<Props> = ({ layerId, recordId }) => {
    const editor = useEditor();
    const layer = editor.services.flatLayer.getLayer(layerId);
    const opacity = layer ? layer.opacity : 1;

    const originOpacityRef = useRef<number | null>(null);

    const curOpacity = useListenActivePickLayerProps(editor, (layer) => {
        return layer ? layer.opacity : 1;
    }) as number;

    const layerOpacity = ~~(curOpacity * 100);

    const handleChange = (value: number) => {
        if (originOpacityRef.current == null) {
            originOpacityRef.current = opacity;
        }
        editor.layer.setOpacity(layerId, value / 100);
    };

    const handleAfterChange = (value: number) => {
        editor.layer.setOpacity(layerId, value / 100, originOpacityRef.current);
        originOpacityRef.current = null;

        Tracker.setLayerOpacity({
            recordId,
            stageType: editor.services.editor.getCanvasType(),
        });
    };

    return (
        <OpacitySlider layout="stack" value={layerOpacity} onChange={handleChange} onAfterChange={handleAfterChange} />
    );
};
